import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { textStyleConst } from '@klarna/designtokens';
import * as FontFamilies from '@bubble-ui/particle-font-families';
import systemFontsDefaultLetterSpacing from '@bubble-ui/particle-system-fonts-default-letter-spacing'; // Content below is copied from @bubble-ui/theme-lollipop to be able to provide lollipop tokens as fallback
// ⬇️

var fontSizesSmall = {
  huge: 40,
  primary: 35,
  secondary: 31,
  tertiary: 27,
  quaternary: 24,
  grande: 21,
  tall: 18,
  body: 16,
  default: 14,
  tiny: 12,
  micro: 10
};
var lollipopLineHeights = {
  base: 1.05,
  double: 1.15,
  high: 1.3,
  highest: 1.45
}; // eslint-disable-next-line max-params

function textStylesFromParameters(fontSizes, lollipopLineHeights) {
  var useRelativeLineHeights = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // eslint-disable-next-line max-params
  function textStyleToken(fontFam, sizeId) {
    var lineHeightId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'base';
    var letterSpacing = arguments.length > 3 ? arguments[3] : undefined;
    return textStyleConst({
      fontFamily: fontFam.fontFamily,
      fontWeight: fontFam.fontWeight,
      fontSize: fontSizes[sizeId],
      lineHeight: useRelativeLineHeights ? Math.round(lollipopLineHeights[lineHeightId] * fontSizes[sizeId]) : lollipopLineHeights[lineHeightId],
      letterSpacing: letterSpacing ? letterSpacing : systemFontsDefaultLetterSpacing(fontSizes[sizeId])
    });
  }

  return {
    'text-style/headings/titles/bold/huge': textStyleToken(FontFamilies.KLARNA_DISPLAY_BOLD, 'huge', 'base'),
    'text-style/headings/titles/bold/primary': textStyleToken(FontFamilies.KLARNA_DISPLAY_BOLD, 'primary', 'base'),
    'text-style/headings/titles/bold/secondary': textStyleToken(FontFamilies.KLARNA_DISPLAY_BOLD, 'secondary', 'base'),
    'text-style/headings/titles/bold/tertiary': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tertiary', 'base'),
    'text-style/headings/titles/bold/quaternary': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'quaternary', 'base'),
    'text-style/headings/titles/bold/grande': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'grande', 'base'),
    'text-style/headings/titles/medium/tertiary': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tertiary', 'base'),
    'text-style/headings/titles/medium/quaternary': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'quaternary', 'base'),
    'text-style/headings/titles/medium/grande': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'grande', 'base'),
    'text-style/headings/blocks/bold/huge': textStyleToken(FontFamilies.KLARNA_DISPLAY_BOLD, 'huge', 'double'),
    'text-style/headings/blocks/bold/primary': textStyleToken(FontFamilies.KLARNA_DISPLAY_BOLD, 'primary', 'double'),
    'text-style/headings/blocks/bold/secondary': textStyleToken(FontFamilies.KLARNA_DISPLAY_BOLD, 'secondary', 'double'),
    'text-style/headings/blocks/bold/tertiary': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tertiary', 'double'),
    'text-style/headings/blocks/bold/quaternary': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'quaternary', 'double'),
    'text-style/headings/blocks/bold/grande': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'grande', 'double'),
    'text-style/headings/blocks/medium/tertiary': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tertiary', 'double'),
    'text-style/headings/blocks/medium/quaternary': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'quaternary', 'double'),
    'text-style/headings/blocks/medium/grande': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'grande', 'double'),
    'text-style/text/labels/grande/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'grande', 'base'),
    'text-style/text/labels/grande/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'grande', 'base'),
    'text-style/text/labels/grande/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'grande', 'base'),
    'text-style/text/labels/tall/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tall', 'base'),
    'text-style/text/labels/tall/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tall', 'base'),
    'text-style/text/labels/tall/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'tall', 'base'),
    'text-style/text/labels/body/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'body', 'base'),
    'text-style/text/labels/body/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'body', 'base'),
    'text-style/text/labels/body/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'body', 'base'),
    'text-style/text/labels/default/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'default', 'base'),
    'text-style/text/labels/default/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'default', 'base'),
    'text-style/text/labels/default/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'default', 'base'),
    'text-style/text/labels/tiny/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tiny', 'base'),
    'text-style/text/labels/tiny/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tiny', 'base'),
    'text-style/text/labels/tiny/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'tiny', 'base'),
    'text-style/text/labels/micro/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'micro', 'base'),
    'text-style/text/labels/micro/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'micro', 'base'),
    'text-style/text/labels/micro/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'micro', 'base'),
    'text-style/text/paragraphs/grande/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'grande', 'high'),
    'text-style/text/paragraphs/grande/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'grande', 'high'),
    'text-style/text/paragraphs/grande/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'grande', 'high'),
    'text-style/text/paragraphs/tall/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tall', 'high'),
    'text-style/text/paragraphs/tall/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tall', 'high'),
    'text-style/text/paragraphs/tall/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'tall', 'high'),
    'text-style/text/paragraphs/body/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'body', 'high'),
    'text-style/text/paragraphs/body/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'body', 'high'),
    'text-style/text/paragraphs/body/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'body', 'high'),
    'text-style/text/paragraphs/default/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'default', 'high'),
    'text-style/text/paragraphs/default/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'default', 'high'),
    'text-style/text/paragraphs/default/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'default', 'high'),
    'text-style/text/paragraphs/tiny/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tiny', 'high'),
    'text-style/text/paragraphs/tiny/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tiny', 'high'),
    'text-style/text/paragraphs/tiny/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'tiny', 'high'),
    'text-style/text/super-paragraphs/grande/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'grande', 'highest'),
    'text-style/text/super-paragraphs/grande/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'grande', 'highest'),
    'text-style/text/super-paragraphs/grande/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'grande', 'highest'),
    'text-style/text/super-paragraphs/tall/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tall', 'highest'),
    'text-style/text/super-paragraphs/tall/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tall', 'highest'),
    'text-style/text/super-paragraphs/tall/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'tall', 'highest'),
    'text-style/text/super-paragraphs/body/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'body', 'highest'),
    'text-style/text/super-paragraphs/body/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'body', 'highest'),
    'text-style/text/super-paragraphs/body/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'body', 'highest'),
    'text-style/text/super-paragraphs/default/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'default', 'highest'),
    'text-style/text/super-paragraphs/default/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'default', 'highest'),
    'text-style/text/super-paragraphs/default/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'default', 'highest'),
    'text-style/text/super-paragraphs/tiny/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, 'tiny', 'highest'),
    'text-style/text/super-paragraphs/tiny/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, 'tiny', 'highest'),
    'text-style/text/super-paragraphs/tiny/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, 'tiny', 'highest')
  };
}

var lollipopTextStyles = textStylesFromParameters(fontSizesSmall, lollipopLineHeights, true); // ⬆️
// Content above is copied from @bubble-ui/theme-lollipop to be able to provide lollipop tokens as fallback

var fontSizes = {
  huge: 48,
  primary: 36,
  secondary: 31,
  tertiary: 27,
  grande: 16,
  //quaternary: 32,
  //grande: 26,
  tall: 19,
  body: 16,
  default: 14,
  tiny: 12 //micro: 10,

};
var lineHeights = {
  huge: 50,
  primary: 40,
  tertiary: 30,
  grande: 25,
  body: 20
};

function textStyleToken(fontFam, fontSize, lineHeight, letterSpacing) {
  return textStyleConst({
    fontFamily: fontFam.fontFamily,
    fontSize: fontSize,
    fontWeight: fontFam.fontWeight,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing ? letterSpacing : systemFontsDefaultLetterSpacing(fontSize)
  });
}

var textStyles = _objectSpread(_objectSpread({}, lollipopTextStyles), {}, {
  'text-style/headings/titles/bold/huge': textStyleToken(FontFamilies.KLARNA_HEADLINE_BOLD, fontSizes.huge, lineHeights.huge),
  'text-style/headings/titles/bold/primary': textStyleToken(FontFamilies.KLARNA_HEADLINE_BOLD, fontSizes.primary, lineHeights.primary),
  'text-style/headings/titles/bold/secondary': textStyleToken(FontFamilies.KLARNA_HEADLINE_BOLD, fontSizes.secondary),
  'text-style/headings/titles/bold/tertiary': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, fontSizes.tertiary, lineHeights.tertiary),
  'text-style/headings/titles/bold/grande': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, fontSizes.grande, lineHeights.grande),
  'text-style/headings/titles/medium/tertiary': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.tall, lineHeights.grande),
  'text-style/text/labels/body/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, fontSizes.body, lineHeights.grande),
  'text-style/text/labels/body/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.body, lineHeights.body),
  'text-style/text/labels/default/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, fontSizes.default, 15),
  'text-style/text/labels/default/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.default, lineHeights.body),
  'text-style/text/labels/tiny/medium': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, fontSizes.tiny, lineHeights.body),
  'text-style/text/paragraphs/body/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, fontSizes.default, lineHeights.body),
  'text-style/text/paragraphs/body/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.body, lineHeights.body),
  'text-style/text/paragraphs/tiny/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.tiny, 20),
  'text-style/text/super-paragraphs/tall/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.tall, lineHeights.tertiary),
  'text-style/text/super-paragraphs/body/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, fontSizes.body, lineHeights.body),
  'text-style/text/super-paragraphs/body/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, fontSizes.body, lineHeights.body),
  'text-style/text/super-paragraphs/body/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.body, lineHeights.body),
  'text-style/text/super-paragraphs/default/bold': textStyleToken(FontFamilies.KLARNA_TEXT_BOLD, fontSizes.default, lineHeights.body),
  'text-style/text/super-paragraphs/default/medium': textStyleToken(FontFamilies.KLARNA_TEXT_MEDIUM, fontSizes.default, lineHeights.body),
  'text-style/text/super-paragraphs/default/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.default, lineHeights.body),
  'text-style/text/super-paragraphs/tiny/regular': textStyleToken(FontFamilies.KLARNA_TEXT_REGULAR, fontSizes.tiny, lineHeights.body)
});

export default textStyles;
//# sourceMappingURL=index.js.map